import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// GA4 property — initial gtag setup lives in public/index.html.
// This component fires a fresh page_view every time React Router changes
// location, so SPA navigation is actually tracked. It also respects a
// simple opt-out: localStorage.setItem("ga_opt_out", "1") disables tracking
// for that browser.
const GA_ID = "G-DZRKFYP66W";

export default function Analytics() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (localStorage.getItem("ga_opt_out") === "1") return;
    if (typeof window.gtag !== "function") return;

    const path = location.pathname + location.search;
    window.gtag("event", "page_view", {
      page_path: path,
      page_location: window.location.href,
      page_title: document.title,
      send_to: GA_ID,
    });
  }, [location.pathname, location.search]);

  return null;
}

// Exported so other components can fire custom events without importing gtag directly:
//   trackEvent('cta_click', { cta: 'nav_contact' })
export function trackEvent(name, params = {}) {
  if (typeof window === "undefined") return;
  if (localStorage.getItem("ga_opt_out") === "1") return;
  if (typeof window.gtag !== "function") return;
  window.gtag("event", name, { ...params, send_to: GA_ID });
}
